var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "详情",
        visible: _vm.drawer,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "50%",
        withHeader: "false",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title-box" }, [_vm._v("基本信息")]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "商品名称" } }, [
            _vm._v(_vm._s(_vm.info.name)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "副标题" } }, [
            _vm._v(_vm._s(_vm.info.subTitle)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动时间" } }, [
            _vm._v(
              _vm._s(_vm.info.startTime) + " 至 " + _vm._s(_vm.info.endTime)
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c(
            "el-descriptions-item",
            { attrs: { label: "活动头图" } },
            [
              _c("el-image", {
                staticStyle: { width: "120px", "margin-left": "30px" },
                attrs: {
                  src: _vm.info.headImgUrl,
                  "preview-src-list": [_vm.info.headImgUrl],
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title-box" }, [_vm._v("活动奖励")]),
      _c(
        "el-table",
        {
          staticStyle: { margin: "0 10px" },
          attrs: {
            data: _vm.info.couponInfoList,
            border: "",
            size: "mini",
            "max-height": "280px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              type: "index",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "优惠券名称", align: "center", prop: "couponName" },
          }),
          _c("el-table-column", {
            attrs: { label: "所属礼包", align: "center", prop: "giftName" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "金额/个",
              align: "center",
              prop: "discountsMoney",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "每次领取数量", align: "center", prop: "num" },
          }),
        ],
        1
      ),
      _c(
        "el-descriptions",
        {
          staticClass: "margin-top-10",
          staticStyle: { "margin-left": "40px" },
          attrs: { column: 1 },
        },
        [
          _c("el-descriptions-item", { attrs: { label: "售价(元)" } }, [
            _vm._v(_vm._s(_vm.info.marketPrice / 100) + " 元"),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动价(元)" } }, [
            _vm._v(_vm._s(_vm.info.salePrice / 100) + " 元"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "margin-bottom": "20px",
          },
        },
        [
          _c("div", { staticClass: "descriptions-text" }, [_vm._v("库存：")]),
          _c(
            "el-descriptions",
            {
              staticStyle: { width: "200px" },
              attrs: {
                column: 2,
                border: "",
                direction: "vertical",
                size: "mini",
                contentStyle: _vm.rowCenter,
                labelStyle: _vm.rowCenter,
              },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "总库存" } }, [
                _vm._v(_vm._s(_vm.info.personTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "剩余库存" } }, [
                _vm._v(_vm._s(_vm.info.surplus)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "descriptions-text" }, [
        _vm._v("每人限购 " + _vm._s(_vm.info.everyPersonTime) + " 次"),
      ]),
      _c("div", { staticClass: "descriptions-text flex" }, [
        _c("div", { staticStyle: { "min-width": "70px" } }, [
          _vm._v("使用规则："),
        ]),
        _c("div", { domProps: { innerHTML: _vm._s(_vm.info.rule) } }),
      ]),
      _c("div", { staticClass: "title-box" }, [_vm._v("其他")]),
      _c(
        "div",
        { staticClass: "bottom-box" },
        [
          _c(
            "el-descriptions",
            { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
                _vm._v(_vm._s(_vm.info.createUser)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "审核人" } }, [
                _vm._v(_vm._s(_vm.info.auditUser || "--")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "状态" } }, [
                _vm._v(_vm._s(_vm.info.statusTr)),
              ]),
              _vm.info.refuseMsg
                ? _c(
                    "el-descriptions-item",
                    { attrs: { label: "不通过原因" } },
                    [_vm._v(_vm._s(_vm.info.refuseMsg))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-descriptions",
            { attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                _vm._v(_vm._s(_vm.info.createTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "审核时间" } }, [
                _vm._v(_vm._s(_vm.info.auditTime || "--")),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }